export const serviceAreas = [
  { name: "Wake Forest", slug: "web-design-wake-forest-nc" },
  { name: "Youngsville", slug: "web-design-youngsville-nc" },
  { name: "Rolesville", slug: "web-design-rolesville-nc" },
  { name: "Franklinton", slug: "web-design-franklinton-nc" },
  { name: "Zebulon", slug: "web-design-zebulon-nc" },
  { name: "Knightdale", slug: "web-design-knightdale-nc" },
  { name: "Wendell", slug: "web-design-wendell-nc" },
  { name: "Louisburg", slug: "web-design-louisburg-nc" },
  { name: "Raleigh", slug: "web-design-raleigh-nc" },
  { name: "Durham", slug: "web-design-durham-nc" },
  { name: "Cary", slug: "web-design-cary-nc" },
  { name: "Apex", slug: "web-design-apex-nc" },
  { name: "Holly Springs", slug: "web-design-holly-springs-nc" },
  { name: "Fuquay-Varina", slug: "web-design-fuquay-varina-nc" },
  { name: "Garner", slug: "web-design-garner-nc" },
  { name: "Clayton", slug: "web-design-clayton-nc" },
  { name: "Smithfield", slug: "web-design-smithfield-nc" },
  { name: "Henderson", slug: "web-design-henderson-nc" },
  { name: "Oxford", slug: "web-design-oxford-nc" },
  { name: "Creedmoor", slug: "web-design-creedmoor-nc" },
  { name: "Morrisville", slug: "web-design-morrisville-nc" },
  { name: "Chapel Hill", slug: "web-design-chapel-hill-nc" },
  { name: "Hillsborough", slug: "web-design-hillsborough-nc" },
  { name: "Bunn", slug: "web-design-bunn-nc" },
  { name: "Stem", slug: "web-design-stem-nc" },
  { name: "Butner", slug: "web-design-butner-nc" },
  { name: "Selma", slug: "web-design-selma-nc" },
  { name: "Angier", slug: "web-design-angier-nc" },
  { name: "Four Oaks", slug: "web-design-four-oaks-nc" },
  { name: "Benson", slug: "web-design-benson-nc" },
  { name: "Pittsboro", slug: "web-design-pittsboro-nc" },
  { name: "Sanford", slug: "web-design-sanford-nc" },
  { name: "Mebane", slug: "web-design-mebane-nc" },
  { name: "Burlington", slug: "web-design-burlington-nc" },
  { name: "Wilson", slug: "web-design-wilson-nc" },
  { name: "Rocky Mount", slug: "web-design-rocky-mount-nc" },
  { name: "Lillington", slug: "web-design-lillington-nc" },
  { name: "Dunn", slug: "web-design-dunn-nc" },
  { name: "Spring Hope", slug: "web-design-spring-hope-nc" },
  { name: "Siler City", slug: "web-design-siler-city-nc" },
];

export const locations = [
  {
    slug: "web-design-wake-forest-nc",
    city: "Wake Forest",
    state: "NC",
    county: "Wake County",
    latitude: "35.9799",
    longitude: "-78.5097",
    description:
      "Wake Forest is one of the fastest-growing towns in North Carolina — and every local business here needs a website that keeps pace. As a website developer serving Wake Forest, I provide full-service web development, website design, and digital marketing for local businesses. Whether you need a new website built from scratch or want to improve your existing site's SEO and performance, I deliver professional results with fixed pricing and fast turnaround.",
    heroHeadline: "Your Wake Forest customers are searching. Let them find you.",
    heroSubheadline: "Website Development & Web Design in Wake Forest, NC",
    nearbyAreas: ["Youngsville", "Rolesville", "Raleigh", "Durham", "Zebulon", "Knightdale", "Franklinton", "Cary"],
    industries: [
      "Medical Practices", "Law Firms", "Dental Offices", "Restaurants",
      "Real Estate Agents", "Contractors", "Fitness Studios", "Salons & Spas",
      "Insurance Agencies", "Accounting Firms", "Chiropractic Offices", "Veterinarians",
    ],
    metaTitle: "Website Development Wake Forest NC | Web Developer — Trika Studio",
    metaDescription:
      "Professional website development and web design in Wake Forest, NC. Trika Studio is a local website developer building custom websites, SEO, and digital marketing for Wake Forest businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "website development Wake Forest NC, website developer Wake Forest, web design Wake Forest NC, website design Wake Forest NC, web development Wake Forest, website design in Wake Forest, web design in Wake Forest, website development in Wake Forest, Wake Forest web design, Wake Forest web developer, web developer Wake Forest North Carolina, small business website Wake Forest NC",
  },
  {
    slug: "web-design-youngsville-nc",
    city: "Youngsville",
    state: "NC",
    county: "Franklin County",
    latitude: "36.0251",
    longitude: "-78.4744",
    description:
      "Youngsville is a tight-knit, growing community where local businesses thrive — but only when customers can find them online. I provide full-service web development and design for Youngsville businesses, building professional websites that drive real growth.",
    heroHeadline: "Youngsville is growing. Is your business growing with it?",
    heroSubheadline: "Web Design, Development & Marketing in Youngsville, NC",
    nearbyAreas: ["Wake Forest", "Franklinton", "Rolesville", "Louisburg", "Henderson", "Oxford", "Zebulon", "Raleigh"],
    industries: [
      "Healthcare & Medical", "Accounting & Tax", "Chiropractic Offices", "Retail Shops",
      "Home Services", "Wellness & Yoga", "Insurance Agencies", "Restaurants",
      "Hair Salons", "Auto Services", "Real Estate Agents", "Dental Offices",
    ],
    metaTitle: "#1 Web Development & Design in Youngsville NC | Trika Studio",
    metaDescription:
      "Top web development company in Youngsville, NC. Locally based web developer building custom websites, SEO, and digital marketing for Franklin County small businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web development Youngsville NC, web design Youngsville NC, web developer Youngsville, website development Youngsville North Carolina, top web development Youngsville, Franklin County web development, Youngsville web design company, small business website Youngsville NC",
  },
  {
    slug: "web-design-rolesville-nc",
    city: "Rolesville",
    state: "NC",
    county: "Wake County",
    latitude: "35.9235",
    longitude: "-78.4575",
    description:
      "Rolesville is one of Wake County's fastest-growing communities. Local businesses here need a strong digital presence to stand out in a competitive market. I build websites that rank locally and convert visitors into paying customers.",
    heroHeadline: "Rolesville businesses deserve more than a template.",
    heroSubheadline: "Web Design, Development & Marketing in Rolesville, NC",
    nearbyAreas: ["Wake Forest", "Youngsville", "Zebulon", "Raleigh", "Knightdale", "Wendell", "Franklinton", "Durham"],
    industries: [
      "Dental Offices", "Contractors", "Fitness Studios", "Salons & Spas",
      "Retail Shops", "Medical Practices", "Childcare Centers", "Real Estate Agents",
      "Home Services", "Restaurants", "Law Firms", "Insurance Agencies",
    ],
    metaTitle: "Web Design Rolesville NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Rolesville, NC. Trika Studio builds professional websites for Wake County businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Rolesville NC, website design Rolesville, web developer Rolesville North Carolina, website development Rolesville NC, website developer Rolesville, Wake County web design, Wake County web development",
  },
  {
    slug: "web-design-franklinton-nc",
    city: "Franklinton",
    state: "NC",
    county: "Franklin County",
    latitude: "36.1010",
    longitude: "-78.4581",
    description:
      "Franklinton businesses deserve a web presence that reflects their quality. Whether you're a law firm, medical practice, or local shop, I build professional websites that help Franklinton businesses compete and grow.",
    heroHeadline: "Put your Franklinton business on the digital map.",
    heroSubheadline: "Web Design, Development & Marketing in Franklinton, NC",
    nearbyAreas: ["Youngsville", "Louisburg", "Wake Forest", "Oxford", "Henderson", "Creedmoor", "Rolesville", "Durham"],
    industries: [
      "Law Firms", "Medical Practices", "Agriculture & Farm Supply", "Home Services",
      "Nonprofits", "Dental Offices", "Retail Shops", "Contractors",
      "Insurance Agencies", "Hair Salons", "Auto Services", "Accounting Firms",
    ],
    metaTitle: "Web Design Franklinton NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Franklinton, NC. Trika Studio builds modern websites for Franklin County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Franklinton NC, website design Franklinton, web developer Franklinton North Carolina, website development Franklinton NC, website developer Franklinton, Franklin County web developer, Franklin County web development",
  },
  {
    slug: "web-design-zebulon-nc",
    city: "Zebulon",
    state: "NC",
    county: "Wake County",
    latitude: "35.8243",
    longitude: "-78.3148",
    description:
      "Zebulon is a growing Wake County town with a vibrant small business community. I help Zebulon businesses build websites that get found on Google and turn online visitors into loyal local customers.",
    heroHeadline: "Zebulon is booming. Your online presence should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Zebulon, NC",
    nearbyAreas: ["Wendell", "Knightdale", "Rolesville", "Wilson's Mills", "Clayton", "Selma", "Smithfield", "Wake Forest"],
    industries: [
      "Auto Services", "Restaurants", "Contractors", "Retail Shops",
      "Healthcare & Medical", "Fitness Studios", "Hair Salons", "Law Firms",
      "Home Services", "Dental Offices", "Insurance Agencies", "Real Estate Agents",
    ],
    metaTitle: "Web Design Zebulon NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Zebulon, NC. Trika Studio builds professional websites for Wake County small businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Zebulon NC, website design Zebulon, web developer Zebulon North Carolina, website development Zebulon NC, website developer Zebulon, Wake County web design Zebulon",
  },
  {
    slug: "web-design-knightdale-nc",
    city: "Knightdale",
    state: "NC",
    county: "Wake County",
    latitude: "35.7879",
    longitude: "-78.4897",
    description:
      "Knightdale is one of Raleigh's fastest-growing suburbs. With more residents and businesses moving in every year, standing out online has never been more important. I build clean, fast websites that put Knightdale businesses on the map.",
    heroHeadline: "Stand out in Knightdale's competitive market.",
    heroSubheadline: "Web Design, Development & Marketing in Knightdale, NC",
    nearbyAreas: ["Zebulon", "Wendell", "Raleigh", "Garner", "Clayton", "Smithfield", "Rolesville", "Durham"],
    industries: [
      "Real Estate Agents", "Medical Practices", "Fitness Studios", "Restaurants",
      "Law Firms", "Dental Offices", "Contractors", "Retail Shops",
      "Hair Salons", "Childcare Centers", "Insurance Agencies", "Accounting Firms",
    ],
    metaTitle: "Web Design Knightdale NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Knightdale, NC. Trika Studio builds fast, modern websites for Wake County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Knightdale NC, website design Knightdale, web developer Knightdale North Carolina, website development Knightdale NC, website developer Knightdale, Knightdale small business website",
  },
  {
    slug: "web-design-wendell-nc",
    city: "Wendell",
    state: "NC",
    county: "Wake County",
    latitude: "35.7810",
    longitude: "-78.3697",
    description:
      "Wendell's small business community is strong — but without a professional website, local customers often can't find you. I help Wendell business owners build affordable, high-quality websites that generate real leads.",
    heroHeadline: "Wendell businesses: get found by customers who need you.",
    heroSubheadline: "Web Design, Development & Marketing in Wendell, NC",
    nearbyAreas: ["Zebulon", "Knightdale", "Rolesville", "Smithfield", "Clayton", "Garner", "Raleigh", "Selma"],
    industries: [
      "Home Services", "Salons & Spas", "Contractors", "Retail Shops",
      "Agriculture & Farming", "Restaurants", "Auto Services", "Childcare Centers",
      "Medical Practices", "Dental Offices", "Real Estate Agents", "Fitness Studios",
    ],
    metaTitle: "Web Design Wendell NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Wendell, NC. Trika Studio builds professional websites for Wake County small businesses. Affordable fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Wendell NC, website design Wendell, web developer Wendell North Carolina, website development Wendell NC, website developer Wendell, Wake County web design Wendell",
  },
  {
    slug: "web-design-louisburg-nc",
    city: "Louisburg",
    state: "NC",
    county: "Franklin County",
    latitude: "36.0990",
    longitude: "-78.3014",
    description:
      "As Franklin County's seat, Louisburg has a rich local business community that deserves a professional online presence. I build modern, SEO-optimized websites for Louisburg businesses that attract new customers and build lasting trust.",
    heroHeadline: "Give your Louisburg business the online presence it deserves.",
    heroSubheadline: "Web Design, Development & Marketing in Louisburg, NC",
    nearbyAreas: ["Franklinton", "Youngsville", "Henderson", "Oxford", "Bunn", "Creedmoor", "Wake Forest", "Durham"],
    industries: [
      "Legal Services", "Medical Practices", "Dental Offices", "Retail Shops",
      "Education & Tutoring", "Nonprofits", "Accounting Firms", "Insurance Agencies",
      "Contractors", "Hair Salons", "Auto Services", "Agriculture & Farm Supply",
    ],
    metaTitle: "Web Design Louisburg NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Louisburg, NC. Trika Studio builds modern websites for Franklin County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Louisburg NC, website design Louisburg, web developer Louisburg North Carolina, website development Louisburg NC, website developer Louisburg, Franklin County web designer, Franklin County web development",
  },
  {
    slug: "web-design-raleigh-nc",
    city: "Raleigh",
    state: "NC",
    county: "Wake County",
    latitude: "35.7796",
    longitude: "-78.6382",
    description:
      "Raleigh is North Carolina's capital and one of the fastest-growing tech hubs in the country. With thousands of small businesses competing for attention, a professional website isn't optional — it's essential. I build high-performance websites and run digital marketing campaigns that help Raleigh businesses stand out.",
    heroHeadline: "Raleigh is competitive. Your website should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Raleigh, NC",
    nearbyAreas: ["Cary", "Garner", "Knightdale", "Wake Forest", "Apex", "Durham", "Morrisville", "Holly Springs"],
    industries: [
      "Tech Startups", "Law Firms", "Medical Practices", "Restaurants",
      "Real Estate Agents", "Contractors", "Fitness Studios", "Salons & Spas",
      "Insurance Agencies", "Accounting Firms", "Dental Offices", "Consulting Firms",
    ],
    metaTitle: "Web Design Raleigh NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design and digital marketing in Raleigh, NC. Custom websites, SEO, and Google Ads for local businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Raleigh NC, website design Raleigh, web developer Raleigh North Carolina, website development Raleigh NC, website developer Raleigh, Raleigh web design company, Raleigh web development, small business website Raleigh",
  },
  {
    slug: "web-design-durham-nc",
    city: "Durham",
    state: "NC",
    county: "Durham County",
    latitude: "35.9940",
    longitude: "-78.8986",
    description:
      "Durham's business scene is thriving — from the American Tobacco Campus to the startups on Main Street. Whether you're a Bull City restaurant, healthcare practice, or growing startup, I build websites that reflect Durham's creative energy and drive real business results.",
    heroHeadline: "Build a website as ambitious as your Durham business.",
    heroSubheadline: "Web Design, Development & Marketing in Durham, NC",
    nearbyAreas: ["Raleigh", "Chapel Hill", "Hillsborough", "Morrisville", "Cary", "Wake Forest", "Creedmoor", "Butner"],
    industries: [
      "Tech Startups", "Restaurants & Breweries", "Healthcare & Medical", "Law Firms",
      "Nonprofits", "Real Estate Agents", "Fitness Studios", "Consulting Firms",
      "Dental Offices", "Retail Shops", "Education", "Creative Agencies",
    ],
    metaTitle: "Web Design Durham NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Durham, NC. Trika Studio builds custom websites for Bull City businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Durham NC, website design Durham, web developer Durham North Carolina, website development Durham NC, website developer Durham, Durham web design, Durham web development, Bull City web developer",
  },
  {
    slug: "web-design-cary-nc",
    city: "Cary",
    state: "NC",
    county: "Wake County",
    latitude: "35.7915",
    longitude: "-78.7811",
    description:
      "Cary consistently ranks as one of the best places to live in America — and its business community reflects that quality. I help Cary businesses build polished, professional websites that match the high standards their customers expect.",
    heroHeadline: "Cary businesses set a high bar. Your website should too.",
    heroSubheadline: "Web Design, Development & Marketing in Cary, NC",
    nearbyAreas: ["Raleigh", "Apex", "Morrisville", "Holly Springs", "Durham", "Garner", "Fuquay-Varina", "Wake Forest"],
    industries: [
      "Medical Practices", "Dental Offices", "Law Firms", "Financial Advisors",
      "Real Estate Agents", "Restaurants", "Fitness Studios", "Salons & Spas",
      "Consulting Firms", "Insurance Agencies", "Contractors", "Retail Shops",
    ],
    metaTitle: "Web Design Cary NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Cary, NC. Trika Studio builds custom, SEO-optimized websites for Cary businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Cary NC, website design Cary, web developer Cary North Carolina, website development Cary NC, website developer Cary, Cary NC web design, Cary web development, small business website Cary",
  },
  {
    slug: "web-design-apex-nc",
    city: "Apex",
    state: "NC",
    county: "Wake County",
    latitude: "35.7327",
    longitude: "-78.8503",
    description:
      "Known as 'the Peak of Good Living,' Apex is one of the Triangle's most desirable towns. Local businesses here benefit from an affluent, educated customer base — but you need a professional online presence to capture them. I build websites that convert Apex visitors into customers.",
    heroHeadline: "The Peak of Good Living deserves peak web design.",
    heroSubheadline: "Web Design, Development & Marketing in Apex, NC",
    nearbyAreas: ["Cary", "Holly Springs", "Fuquay-Varina", "Raleigh", "Morrisville", "Garner", "Durham", "Angier"],
    industries: [
      "Dental Offices", "Medical Practices", "Real Estate Agents", "Restaurants",
      "Fitness Studios", "Law Firms", "Financial Advisors", "Contractors",
      "Salons & Spas", "Insurance Agencies", "Retail Shops", "Consulting Firms",
    ],
    metaTitle: "Web Design Apex NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Apex, NC. Trika Studio builds custom websites for Wake County businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Apex NC, website design Apex, web developer Apex North Carolina, website development Apex NC, website developer Apex, Apex NC web design",
  },
  {
    slug: "web-design-holly-springs-nc",
    city: "Holly Springs",
    state: "NC",
    county: "Wake County",
    latitude: "35.6513",
    longitude: "-78.8336",
    description:
      "Holly Springs has exploded in growth over the past decade, with new businesses opening every month. Standing out in this rapidly expanding market requires a website that's fast, professional, and optimized for local search. That's exactly what I build.",
    heroHeadline: "Holly Springs is growing fast. Is your business keeping up?",
    heroSubheadline: "Web Design, Development & Marketing in Holly Springs, NC",
    nearbyAreas: ["Apex", "Fuquay-Varina", "Cary", "Angier", "Garner", "Raleigh", "Clayton", "Morrisville"],
    industries: [
      "Medical Practices", "Dental Offices", "Restaurants", "Fitness Studios",
      "Real Estate Agents", "Contractors", "Childcare Centers", "Salons & Spas",
      "Insurance Agencies", "Retail Shops", "Law Firms", "Veterinarians",
    ],
    metaTitle: "Web Design Holly Springs NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Holly Springs, NC. Trika Studio builds modern, SEO-optimized websites for local businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Holly Springs NC, website design Holly Springs, web developer Holly Springs North Carolina, website development Holly Springs NC, website developer Holly Springs, Holly Springs web design",
  },
  {
    slug: "web-design-fuquay-varina-nc",
    city: "Fuquay-Varina",
    state: "NC",
    county: "Wake County",
    latitude: "35.5843",
    longitude: "-78.8001",
    description:
      "Fuquay-Varina's charming downtown and growing population make it a prime spot for local businesses. But without a professional website, potential customers drive right past. I build websites that put Fuquay-Varina businesses on the digital map.",
    heroHeadline: "Put your Fuquay-Varina business on the digital map.",
    heroSubheadline: "Web Design, Development & Marketing in Fuquay-Varina, NC",
    nearbyAreas: ["Holly Springs", "Apex", "Angier", "Garner", "Clayton", "Raleigh", "Cary", "Four Oaks"],
    industries: [
      "Restaurants & Breweries", "Contractors", "Real Estate Agents", "Salons & Spas",
      "Auto Services", "Medical Practices", "Dental Offices", "Retail Shops",
      "Fitness Studios", "Insurance Agencies", "Home Services", "Childcare Centers",
    ],
    metaTitle: "Web Design Fuquay-Varina NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Fuquay-Varina, NC. Trika Studio builds professional websites for local businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Fuquay-Varina NC, website design Fuquay-Varina, web developer Fuquay-Varina North Carolina, website development Fuquay-Varina NC, website developer Fuquay-Varina",
  },
  {
    slug: "web-design-garner-nc",
    city: "Garner",
    state: "NC",
    county: "Wake County",
    latitude: "35.7113",
    longitude: "-78.6142",
    description:
      "Garner is a growing community just south of Raleigh with a strong small business presence. I help Garner businesses build professional websites that attract local customers and compete with the larger Raleigh market next door.",
    heroHeadline: "Garner businesses: compete with Raleigh online.",
    heroSubheadline: "Web Design, Development & Marketing in Garner, NC",
    nearbyAreas: ["Raleigh", "Clayton", "Knightdale", "Fuquay-Varina", "Smithfield", "Cary", "Holly Springs", "Apex"],
    industries: [
      "Contractors", "Auto Services", "Restaurants", "Medical Practices",
      "Dental Offices", "Real Estate Agents", "Hair Salons", "Retail Shops",
      "Insurance Agencies", "Fitness Studios", "Home Services", "Law Firms",
    ],
    metaTitle: "Web Design Garner NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Garner, NC. Trika Studio builds fast, modern websites for Wake County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Garner NC, website design Garner, web developer Garner North Carolina, website development Garner NC, website developer Garner, Garner web design",
  },
  {
    slug: "web-design-clayton-nc",
    city: "Clayton",
    state: "NC",
    county: "Johnston County",
    latitude: "35.6507",
    longitude: "-78.4564",
    description:
      "Clayton is one of Johnston County's fastest-growing towns, attracting new residents and businesses alike. I build professional websites that help Clayton businesses capture this growing market and stand out from competitors.",
    heroHeadline: "Clayton is booming. Your online presence should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Clayton, NC",
    nearbyAreas: ["Garner", "Smithfield", "Knightdale", "Raleigh", "Selma", "Four Oaks", "Fuquay-Varina", "Wendell"],
    industries: [
      "Contractors", "Restaurants", "Medical Practices", "Real Estate Agents",
      "Auto Services", "Dental Offices", "Fitness Studios", "Retail Shops",
      "Home Services", "Insurance Agencies", "Hair Salons", "Childcare Centers",
    ],
    metaTitle: "Web Design Clayton NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Clayton, NC. Trika Studio builds professional websites for Johnston County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Clayton NC, website design Clayton, web developer Clayton North Carolina, website development Clayton NC, website developer Clayton, Johnston County web design, Johnston County web development",
  },
  {
    slug: "web-design-smithfield-nc",
    city: "Smithfield",
    state: "NC",
    county: "Johnston County",
    latitude: "35.5085",
    longitude: "-78.3395",
    description:
      "As Johnston County's county seat, Smithfield has a strong local business community anchored by downtown shops, restaurants, and professional services. I build modern websites that help Smithfield businesses grow and attract customers from across the region.",
    heroHeadline: "Give your Smithfield business a website that works as hard as you do.",
    heroSubheadline: "Web Design, Development & Marketing in Smithfield, NC",
    nearbyAreas: ["Clayton", "Selma", "Four Oaks", "Garner", "Wendell", "Knightdale", "Raleigh", "Zebulon"],
    industries: [
      "Law Firms", "Medical Practices", "Restaurants", "Retail Shops",
      "Contractors", "Auto Services", "Dental Offices", "Insurance Agencies",
      "Real Estate Agents", "Agriculture & Farm Supply", "Hair Salons", "Accounting Firms",
    ],
    metaTitle: "Web Design Smithfield NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Smithfield, NC. Trika Studio builds modern websites for Johnston County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Smithfield NC, website design Smithfield, web developer Smithfield North Carolina, website development Smithfield NC, website developer Smithfield, Johnston County web developer, Johnston County web development",
  },
  {
    slug: "web-design-henderson-nc",
    city: "Henderson",
    state: "NC",
    county: "Vance County",
    latitude: "36.3293",
    longitude: "-78.3992",
    description:
      "Henderson is the heart of Vance County, with a close-knit business community that's ready for digital growth. I help Henderson businesses build professional websites that bring in new customers and establish credibility online.",
    heroHeadline: "Henderson businesses deserve a professional online presence.",
    heroSubheadline: "Web Design, Development & Marketing in Henderson, NC",
    nearbyAreas: ["Oxford", "Louisburg", "Franklinton", "Creedmoor", "Youngsville", "Wake Forest", "Durham", "Butner"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants", "Retail Shops",
      "Auto Services", "Contractors", "Insurance Agencies", "Dental Offices",
      "Nonprofits", "Agriculture & Farm Supply", "Hair Salons", "Real Estate Agents",
    ],
    metaTitle: "Web Design Henderson NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Henderson, NC. Trika Studio builds professional websites for Vance County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Henderson NC, website design Henderson, web developer Henderson North Carolina, website development Henderson NC, website developer Henderson, Vance County web design, Vance County web development",
  },
  {
    slug: "web-design-oxford-nc",
    city: "Oxford",
    state: "NC",
    county: "Granville County",
    latitude: "36.3107",
    longitude: "-78.5911",
    description:
      "Oxford is Granville County's county seat with a charming historic downtown and growing business community. I build modern, professional websites that help Oxford businesses reach more customers and compete in the digital age.",
    heroHeadline: "Bring your Oxford business into the digital age.",
    heroSubheadline: "Web Design, Development & Marketing in Oxford, NC",
    nearbyAreas: ["Henderson", "Creedmoor", "Butner", "Stem", "Franklinton", "Louisburg", "Durham", "Wake Forest"],
    industries: [
      "Law Firms", "Medical Practices", "Restaurants", "Retail Shops",
      "Contractors", "Agriculture & Farm Supply", "Insurance Agencies", "Dental Offices",
      "Auto Services", "Nonprofits", "Real Estate Agents", "Accounting Firms",
    ],
    metaTitle: "Web Design Oxford NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Oxford, NC. Trika Studio builds modern websites for Granville County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Oxford NC, website design Oxford, web developer Oxford North Carolina, website development Oxford NC, website developer Oxford, Granville County web design, Granville County web development",
  },
  {
    slug: "web-design-creedmoor-nc",
    city: "Creedmoor",
    state: "NC",
    county: "Granville County",
    latitude: "36.1224",
    longitude: "-78.6861",
    description:
      "Creedmoor is a small but growing town between Durham and the Virginia border. Local businesses here need an online presence to capture both local customers and travelers passing through. I build websites that work for Creedmoor's unique market.",
    heroHeadline: "Small town, big potential. Let's build your online presence.",
    heroSubheadline: "Web Design, Development & Marketing in Creedmoor, NC",
    nearbyAreas: ["Oxford", "Butner", "Stem", "Durham", "Franklinton", "Youngsville", "Wake Forest", "Henderson"],
    industries: [
      "Contractors", "Auto Services", "Restaurants", "Retail Shops",
      "Home Services", "Medical Practices", "Agriculture & Farm Supply", "Hair Salons",
      "Real Estate Agents", "Insurance Agencies", "Dental Offices", "Veterinarians",
    ],
    metaTitle: "Web Design Creedmoor NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Creedmoor, NC. Trika Studio builds professional websites for Granville County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Creedmoor NC, website design Creedmoor, web developer Creedmoor North Carolina, website development Creedmoor NC, website developer Creedmoor, Granville County web developer, Granville County web development",
  },
  {
    slug: "web-design-morrisville-nc",
    city: "Morrisville",
    state: "NC",
    county: "Wake County",
    latitude: "35.8232",
    longitude: "-78.8253",
    description:
      "Morrisville is at the heart of the Triangle — home to Research Triangle Park, RDU Airport, and a booming corridor of tech companies and diverse local businesses. With one of the most educated and internationally diverse populations in North Carolina, Morrisville businesses compete for a sophisticated customer base that researches everything online before spending a dollar.",
    heroHeadline: "Morrisville is at the heart of the Triangle. Is your website keeping up?",
    heroSubheadline: "Web Design, Development & Marketing in Morrisville, NC",
    nearbyAreas: ["Cary", "Durham", "Raleigh", "Apex", "Chapel Hill", "Research Triangle Park", "Holly Springs", "Fuquay-Varina"],
    industries: [
      "Tech Companies", "Medical Practices", "Dental Offices", "Restaurants",
      "Retail Shops", "Financial Services", "Law Firms", "Fitness Studios",
      "Real Estate Agents", "Consulting Firms", "Insurance Agencies", "Childcare Centers",
    ],
    metaTitle: "Web Design Morrisville NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design and digital marketing in Morrisville, NC. Trika Studio builds custom websites for Wake County businesses near RTP and RDU. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Morrisville NC, website design Morrisville, web developer Morrisville North Carolina, website development Morrisville NC, website developer Morrisville, RTP web developer, Research Triangle Park web design, Morrisville small business website",
  },
  {
    slug: "web-design-chapel-hill-nc",
    city: "Chapel Hill",
    state: "NC",
    county: "Orange County",
    latitude: "35.9132",
    longitude: "-79.0558",
    description:
      "Chapel Hill is home to UNC and one of the most educated consumer bases in North Carolina. Whether you're serving students, faculty, long-term residents, or medical patients at UNC Health, your website needs to reflect the sophistication and quality your Chapel Hill clientele expects. I build websites that match that standard.",
    heroHeadline: "Chapel Hill sets the bar high. Your website should clear it.",
    heroSubheadline: "Web Design, Development & Marketing in Chapel Hill, NC",
    nearbyAreas: ["Durham", "Hillsborough", "Morrisville", "Cary", "Pittsboro", "Mebane", "Raleigh", "Apex"],
    industries: [
      "Medical & Healthcare", "Law Firms", "Restaurants & Cafes", "Retail Boutiques",
      "Fitness Studios", "Dental Offices", "Consulting Firms", "Nonprofits",
      "Real Estate Agents", "Financial Advisors", "Childcare Centers", "Salons & Spas",
    ],
    metaTitle: "Web Design Chapel Hill NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Chapel Hill, NC. Trika Studio builds custom, high-quality websites for Orange County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Chapel Hill NC, website design Chapel Hill, web developer Chapel Hill North Carolina, website development Chapel Hill NC, website developer Chapel Hill, UNC area web design, Orange County web developer, Chapel Hill small business website",
  },
  {
    slug: "web-design-hillsborough-nc",
    city: "Hillsborough",
    state: "NC",
    county: "Orange County",
    latitude: "36.0751",
    longitude: "-79.1003",
    description:
      "Hillsborough's charming historic downtown is home to a thriving community of independent businesses, artisans, restaurants, and professional services. As Orange County's seat, Hillsborough draws customers from across the county and beyond. I build websites that honor your roots while driving modern digital growth for Hillsborough businesses.",
    heroHeadline: "Historic downtown, modern customers — get a website that bridges both.",
    heroSubheadline: "Web Design, Development & Marketing in Hillsborough, NC",
    nearbyAreas: ["Durham", "Chapel Hill", "Mebane", "Oxford", "Creedmoor", "Butner", "Raleigh", "Burlington"],
    industries: [
      "Restaurants & Cafes", "Art Galleries & Studios", "Law Firms", "Medical Practices",
      "Retail Boutiques", "Contractors", "Real Estate Agents", "Insurance Agencies",
      "Dental Offices", "Home Services", "Nonprofits", "Agriculture & Farm Supply",
    ],
    metaTitle: "Web Design Hillsborough NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Hillsborough, NC. Trika Studio builds professional websites for Orange County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Hillsborough NC, website design Hillsborough, web developer Hillsborough North Carolina, website development Hillsborough NC, website developer Hillsborough, Orange County web design, Orange County web developer",
  },
  {
    slug: "web-design-bunn-nc",
    city: "Bunn",
    state: "NC",
    county: "Franklin County",
    latitude: "36.1371",
    longitude: "-78.2314",
    description:
      "Bunn is a small but growing Franklin County community right in Trika Studio's backyard. Local businesses here serve a loyal community that values quality and trust. I build affordable, professional websites for Bunn businesses that get found by local customers and reach buyers across Franklin County.",
    heroHeadline: "Bunn's loyal community is searching. Make sure they find you.",
    heroSubheadline: "Web Design, Development & Marketing in Bunn, NC",
    nearbyAreas: ["Youngsville", "Franklinton", "Louisburg", "Spring Hope", "Rocky Mount", "Henderson", "Oxford", "Wake Forest"],
    industries: [
      "Agriculture & Farm Supply", "Contractors", "Home Services", "Auto Services",
      "Retail Shops", "Restaurants", "Hair Salons", "Medical Practices",
      "Insurance Agencies", "Real Estate Agents", "Childcare Centers", "Veterinarians",
    ],
    metaTitle: "Web Design Bunn NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Affordable web design in Bunn, NC. Trika Studio builds professional websites for Franklin County small businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Bunn NC, website design Bunn, web developer Bunn North Carolina, website development Bunn NC, website developer Bunn, Franklin County web design, Bunn small business website",
  },
  {
    slug: "web-design-stem-nc",
    city: "Stem",
    state: "NC",
    county: "Granville County",
    latitude: "36.1932",
    longitude: "-78.7204",
    description:
      "Stem is a tight-knit Granville County community where word-of-mouth is powerful — but a professional website makes that word travel further. Local businesses here serve a loyal base of residents while also attracting customers from Oxford, Creedmoor, and Durham. I build websites that extend your local reputation across the region.",
    heroHeadline: "Stem's local reputation is strong. A website makes it travel further.",
    heroSubheadline: "Web Design, Development & Marketing in Stem, NC",
    nearbyAreas: ["Oxford", "Creedmoor", "Butner", "Durham", "Franklinton", "Henderson", "Youngsville", "Wake Forest"],
    industries: [
      "Agriculture & Farm Supply", "Contractors", "Home Services", "Auto Services",
      "Retail Shops", "Restaurants", "Hair Salons", "Real Estate Agents",
      "Insurance Agencies", "Veterinarians", "Childcare Centers", "Medical Practices",
    ],
    metaTitle: "Web Design Stem NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Stem, NC. Trika Studio builds professional websites for Granville County small businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Stem NC, website design Stem, web developer Stem North Carolina, website development Stem NC, website developer Stem, Granville County web design, Stem small business website",
  },
  {
    slug: "web-design-butner-nc",
    city: "Butner",
    state: "NC",
    county: "Granville County",
    latitude: "36.1365",
    longitude: "-78.7469",
    description:
      "Butner is a growing Granville County community conveniently located between Durham, Oxford, and Creedmoor. Local businesses serve residents, healthcare workers, and commuters passing through. I build professional, affordable websites that help Butner businesses stand out in this competitive regional market.",
    heroHeadline: "Give your Butner business the digital presence it deserves.",
    heroSubheadline: "Web Design, Development & Marketing in Butner, NC",
    nearbyAreas: ["Creedmoor", "Oxford", "Stem", "Durham", "Henderson", "Franklinton", "Youngsville", "Wake Forest"],
    industries: [
      "Medical Practices", "Home Services", "Contractors", "Retail Shops",
      "Auto Services", "Restaurants", "Hair Salons", "Insurance Agencies",
      "Real Estate Agents", "Childcare Centers", "Agriculture & Farm Supply", "Dental Offices",
    ],
    metaTitle: "Web Design Butner NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Butner, NC. Trika Studio builds professional websites for Granville County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Butner NC, website design Butner, web developer Butner North Carolina, website development Butner NC, website developer Butner, Granville County web design, Butner small business website",
  },
  {
    slug: "web-design-selma-nc",
    city: "Selma",
    state: "NC",
    county: "Johnston County",
    latitude: "35.5368",
    longitude: "-78.2853",
    description:
      "Selma sits at the intersection of I-95 and US-70, making it a natural hub for local businesses that serve both Johnston County residents and travelers passing through. With one of the region's premier antique districts and a growing retail corridor, Selma businesses need websites that capture traffic from both directions.",
    heroHeadline: "Selma: where I-95 meets opportunity. Capture it online.",
    heroSubheadline: "Web Design, Development & Marketing in Selma, NC",
    nearbyAreas: ["Smithfield", "Clayton", "Four Oaks", "Benson", "Garner", "Dunn", "Wilson", "Raleigh"],
    industries: [
      "Antique Shops & Retail", "Restaurants", "Auto Services", "Contractors",
      "Medical Practices", "Real Estate Agents", "Home Services", "Hair Salons",
      "Insurance Agencies", "Agriculture & Farm Supply", "Dental Offices", "Fitness Studios",
    ],
    metaTitle: "Web Design Selma NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Selma, NC. Trika Studio builds professional websites for Johnston County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Selma NC, website design Selma, web developer Selma North Carolina, website development Selma NC, website developer Selma, Johnston County web design, Selma small business website",
  },
  {
    slug: "web-design-angier-nc",
    city: "Angier",
    state: "NC",
    county: "Harnett County",
    latitude: "35.5143",
    longitude: "-78.7404",
    description:
      "Angier is one of Harnett County's fastest-growing communities, attracting families from the Triangle looking for more space at lower costs. That means a steady wave of new residents searching for local services — dentists, contractors, restaurants, salons, and more. A professional website ensures your Angier business is the one they find first.",
    heroHeadline: "Angier is growing fast. Be the business new residents find first.",
    heroSubheadline: "Web Design, Development & Marketing in Angier, NC",
    nearbyAreas: ["Fuquay-Varina", "Apex", "Holly Springs", "Lillington", "Four Oaks", "Dunn", "Garner", "Clayton"],
    industries: [
      "Contractors", "Medical Practices", "Dental Offices", "Restaurants",
      "Fitness Studios", "Real Estate Agents", "Hair Salons", "Childcare Centers",
      "Home Services", "Retail Shops", "Insurance Agencies", "Auto Services",
    ],
    metaTitle: "Web Design Angier NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Angier, NC. Trika Studio builds professional websites for Harnett County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Angier NC, website design Angier, web developer Angier North Carolina, website development Angier NC, website developer Angier, Harnett County web design, Angier small business website",
  },
  {
    slug: "web-design-four-oaks-nc",
    city: "Four Oaks",
    state: "NC",
    county: "Johnston County",
    latitude: "35.4468",
    longitude: "-78.4236",
    description:
      "Four Oaks is a Johnston County community with a strong agricultural and small business heritage. As Johnston County continues its rapid growth, Four Oaks businesses are well-positioned to capture both longtime locals and new residents. I build modern, professional websites that help Four Oaks businesses grow their customer base.",
    heroHeadline: "Four Oaks businesses: reach more customers with a professional website.",
    heroSubheadline: "Web Design, Development & Marketing in Four Oaks, NC",
    nearbyAreas: ["Smithfield", "Selma", "Benson", "Clayton", "Angier", "Dunn", "Garner", "Fuquay-Varina"],
    industries: [
      "Agriculture & Farm Supply", "Contractors", "Auto Services", "Restaurants",
      "Retail Shops", "Home Services", "Medical Practices", "Hair Salons",
      "Insurance Agencies", "Real Estate Agents", "Childcare Centers", "Veterinarians",
    ],
    metaTitle: "Web Design Four Oaks NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Four Oaks, NC. Trika Studio builds professional websites for Johnston County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Four Oaks NC, website design Four Oaks, web developer Four Oaks North Carolina, website development Four Oaks NC, website developer Four Oaks, Johnston County web design",
  },
  {
    slug: "web-design-benson-nc",
    city: "Benson",
    state: "NC",
    county: "Johnston County",
    latitude: "35.3818",
    longitude: "-78.5461",
    description:
      "Benson is famous for the Benson Mule Days festival — a testament to this community's deep local pride and business spirit. Beyond the festival, Benson has a strong year-round small business community serving Johnston County residents. I build websites that carry your Benson business's pride into the digital world and attract customers every month.",
    heroHeadline: "Benson's community spirit is legendary. Your website should match it.",
    heroSubheadline: "Web Design, Development & Marketing in Benson, NC",
    nearbyAreas: ["Smithfield", "Four Oaks", "Selma", "Dunn", "Angier", "Clayton", "Lillington", "Garner"],
    industries: [
      "Agriculture & Farm Supply", "Restaurants", "Contractors", "Auto Services",
      "Retail Shops", "Home Services", "Hair Salons", "Medical Practices",
      "Insurance Agencies", "Real Estate Agents", "Childcare Centers", "Dental Offices",
    ],
    metaTitle: "Web Design Benson NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Benson, NC. Trika Studio builds professional websites for Johnston County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Benson NC, website design Benson, web developer Benson North Carolina, website development Benson NC, website developer Benson, Johnston County web design, Benson small business website",
  },
  {
    slug: "web-design-pittsboro-nc",
    city: "Pittsboro",
    state: "NC",
    county: "Chatham County",
    latitude: "35.7235",
    longitude: "-79.1759",
    description:
      "Pittsboro is experiencing explosive growth thanks to Chatham Park — one of the largest master-planned communities on the East Coast. Thousands of new residents are arriving every year, searching online for local restaurants, healthcare providers, contractors, and services. The businesses that have strong websites are capturing this growth. Is yours one of them?",
    heroHeadline: "Chatham Park is bringing thousands of new customers to Pittsboro. Are you ready?",
    heroSubheadline: "Web Design, Development & Marketing in Pittsboro, NC",
    nearbyAreas: ["Chapel Hill", "Siler City", "Sanford", "Apex", "Cary", "Durham", "Hillsborough", "Raleigh"],
    industries: [
      "Medical Practices", "Dental Offices", "Contractors", "Restaurants",
      "Real Estate Agents", "Retail Shops", "Fitness Studios", "Childcare Centers",
      "Home Services", "Law Firms", "Insurance Agencies", "Salons & Spas",
    ],
    metaTitle: "Web Design Pittsboro NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Pittsboro, NC. Trika Studio builds professional websites for Chatham County businesses near Chatham Park. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Pittsboro NC, website design Pittsboro, web developer Pittsboro North Carolina, website development Pittsboro NC, website developer Pittsboro, Chatham County web design, Chatham Park web developer",
  },
  {
    slug: "web-design-sanford-nc",
    city: "Sanford",
    state: "NC",
    county: "Lee County",
    latitude: "35.4796",
    longitude: "-79.1773",
    description:
      "Sanford is Lee County's largest city and the commercial hub for surrounding communities. With a diverse economy spanning manufacturing, healthcare, retail, and professional services, Sanford businesses serve customers from across central North Carolina. A professional website puts your Sanford business in front of all of them.",
    heroHeadline: "Sanford businesses deserve more than word-of-mouth — get online.",
    heroSubheadline: "Web Design, Development & Marketing in Sanford, NC",
    nearbyAreas: ["Pittsboro", "Siler City", "Lillington", "Dunn", "Apex", "Cary", "Chapel Hill", "Raleigh"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants", "Manufacturing & Industrial",
      "Retail Shops", "Dental Offices", "Contractors", "Auto Services",
      "Insurance Agencies", "Real Estate Agents", "Hair Salons", "Fitness Studios",
    ],
    metaTitle: "Web Design Sanford NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Sanford, NC. Trika Studio builds professional websites for Lee County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Sanford NC, website design Sanford, web developer Sanford North Carolina, website development Sanford NC, website developer Sanford, Lee County web design, Sanford small business website",
  },
  {
    slug: "web-design-mebane-nc",
    city: "Mebane",
    state: "NC",
    county: "Alamance County",
    latitude: "36.0960",
    longitude: "-79.2670",
    description:
      "Mebane sits along the I-40 and I-85 corridors between Raleigh and Greensboro, making it one of the Triangle's most strategically positioned growing cities. With explosive residential growth and proximity to major distribution hubs, Mebane businesses serve a rapidly expanding population. I build websites that help Mebane businesses capture this growing market.",
    heroHeadline: "Mebane is booming along the I-40 corridor. Capture the growth online.",
    heroSubheadline: "Web Design, Development & Marketing in Mebane, NC",
    nearbyAreas: ["Burlington", "Hillsborough", "Durham", "Chapel Hill", "Graham", "Saxapahaw", "Oxford", "Creedmoor"],
    industries: [
      "Contractors", "Medical Practices", "Restaurants", "Retail Shops",
      "Auto Services", "Dental Offices", "Real Estate Agents", "Home Services",
      "Fitness Studios", "Childcare Centers", "Insurance Agencies", "Hair Salons",
    ],
    metaTitle: "Web Design Mebane NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Mebane, NC. Trika Studio builds professional websites for Alamance County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Mebane NC, website design Mebane, web developer Mebane North Carolina, website development Mebane NC, website developer Mebane, Alamance County web design, Mebane small business website",
  },
  {
    slug: "web-design-burlington-nc",
    city: "Burlington",
    state: "NC",
    county: "Alamance County",
    latitude: "36.0957",
    longitude: "-79.4378",
    description:
      "Burlington is Alamance County's largest city and the commercial hub for the western Triangle region between Raleigh and Greensboro. With a diverse economy spanning healthcare, retail, manufacturing, and professional services, Burlington businesses compete in a mid-sized city market. I build websites that help Burlington businesses win online.",
    heroHeadline: "Burlington: Alamance County's biggest market. Own it digitally.",
    heroSubheadline: "Web Design, Development & Marketing in Burlington, NC",
    nearbyAreas: ["Mebane", "Graham", "Hillsborough", "Durham", "Chapel Hill", "Raleigh", "Greensboro", "Pittsboro"],
    industries: [
      "Medical Practices", "Law Firms", "Dental Offices", "Retail Shops",
      "Restaurants", "Contractors", "Auto Services", "Real Estate Agents",
      "Fitness Studios", "Salons & Spas", "Insurance Agencies", "Manufacturing",
    ],
    metaTitle: "Web Design Burlington NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Burlington, NC. Trika Studio builds professional websites for Alamance County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Burlington NC, website design Burlington, web developer Burlington North Carolina, website development Burlington NC, website developer Burlington, Alamance County web design, Burlington small business website",
  },
  {
    slug: "web-design-wilson-nc",
    city: "Wilson",
    state: "NC",
    county: "Wilson County",
    latitude: "35.7215",
    longitude: "-77.9158",
    description:
      "Wilson is a gateway to eastern North Carolina — a mid-sized city with a strong healthcare, retail, and professional services economy. Known for its BBQ culture and growing downtown arts scene, Wilson businesses serve both loyal locals and visitors from across eastern NC. I build websites that help Wilson businesses establish a strong digital presence.",
    heroHeadline: "Wilson, NC: eastern Carolina's commerce hub needs a strong digital hub.",
    heroSubheadline: "Web Design, Development & Marketing in Wilson, NC",
    nearbyAreas: ["Rocky Mount", "Selma", "Smithfield", "Raleigh", "Spring Hope", "Durham", "Garner", "Clayton"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants & BBQ", "Retail Shops",
      "Dental Offices", "Contractors", "Real Estate Agents", "Auto Services",
      "Insurance Agencies", "Fitness Studios", "Hair Salons", "Nonprofits",
    ],
    metaTitle: "Web Design Wilson NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Wilson, NC. Trika Studio builds professional websites for Wilson County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Wilson NC, website design Wilson, web developer Wilson North Carolina, website development Wilson NC, website developer Wilson, Wilson County web design, Wilson NC small business website",
  },
  {
    slug: "web-design-rocky-mount-nc",
    city: "Rocky Mount",
    state: "NC",
    county: "Nash County",
    latitude: "35.9382",
    longitude: "-77.7905",
    description:
      "Rocky Mount is one of eastern North Carolina's largest cities, straddling Nash and Edgecombe counties with a diverse economy anchored by healthcare, manufacturing, and a revitalized downtown. From the Tar River District to Battle Park, Rocky Mount businesses serve a loyal local market and attract visitors from across the region. I build websites that match Rocky Mount's ambition.",
    heroHeadline: "Rocky Mount is eastern NC's largest market. Compete at that level online.",
    heroSubheadline: "Web Design, Development & Marketing in Rocky Mount, NC",
    nearbyAreas: ["Wilson", "Spring Hope", "Henderson", "Raleigh", "Bunn", "Franklinton", "Durham", "Oxford"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants", "Retail Shops",
      "Manufacturing & Industrial", "Dental Offices", "Contractors", "Auto Services",
      "Real Estate Agents", "Insurance Agencies", "Nonprofits", "Fitness Studios",
    ],
    metaTitle: "Web Design Rocky Mount NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Rocky Mount, NC. Trika Studio builds professional websites for Nash County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Rocky Mount NC, website design Rocky Mount, web developer Rocky Mount North Carolina, website development Rocky Mount NC, website developer Rocky Mount, Nash County web design, Rocky Mount small business website",
  },
  {
    slug: "web-design-lillington-nc",
    city: "Lillington",
    state: "NC",
    county: "Harnett County",
    latitude: "35.3971",
    longitude: "-78.8147",
    description:
      "Lillington is Harnett County's county seat and the administrative heart of one of North Carolina's fastest-growing counties. As more Triangle families move south along US-401 and NC-87, Lillington businesses are capturing new residents who need every local service imaginable. A professional website ensures your business is what they find.",
    heroHeadline: "Harnett County is booming. Lillington businesses should lead the way.",
    heroSubheadline: "Web Design, Development & Marketing in Lillington, NC",
    nearbyAreas: ["Angier", "Dunn", "Fuquay-Varina", "Holly Springs", "Sanford", "Benson", "Four Oaks", "Raleigh"],
    industries: [
      "Medical Practices", "Law Firms", "Dental Offices", "Contractors",
      "Restaurants", "Real Estate Agents", "Auto Services", "Home Services",
      "Retail Shops", "Insurance Agencies", "Hair Salons", "Childcare Centers",
    ],
    metaTitle: "Web Design Lillington NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Lillington, NC. Trika Studio builds professional websites for Harnett County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Lillington NC, website design Lillington, web developer Lillington North Carolina, website development Lillington NC, website developer Lillington, Harnett County web design, Lillington small business website",
  },
  {
    slug: "web-design-dunn-nc",
    city: "Dunn",
    state: "NC",
    county: "Harnett County",
    latitude: "35.3060",
    longitude: "-78.6092",
    description:
      "Dunn is Harnett County's largest city and one of the most important commercial centers along the I-95 corridor in central North Carolina. With strong retail, healthcare, and service industries anchored by a historic downtown, Dunn businesses serve both local residents and travelers. A professional website captures all of that traffic.",
    heroHeadline: "Dunn is Harnett County's commercial hub. Capture it online.",
    heroSubheadline: "Web Design, Development & Marketing in Dunn, NC",
    nearbyAreas: ["Lillington", "Benson", "Angier", "Four Oaks", "Selma", "Fuquay-Varina", "Smithfield", "Raleigh"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants", "Retail Shops",
      "Dental Offices", "Contractors", "Auto Services", "Real Estate Agents",
      "Agriculture & Farm Supply", "Insurance Agencies", "Hair Salons", "Fitness Studios",
    ],
    metaTitle: "Web Design Dunn NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Dunn, NC. Trika Studio builds professional websites for Harnett County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Dunn NC, website design Dunn, web developer Dunn North Carolina, website development Dunn NC, website developer Dunn, Harnett County web design, Dunn small business website",
  },
  {
    slug: "web-design-spring-hope-nc",
    city: "Spring Hope",
    state: "NC",
    county: "Nash County",
    latitude: "35.9460",
    longitude: "-78.1133",
    description:
      "Spring Hope is a Nash County community known for its annual Apple Festival and a tight-knit local business community. Small town doesn't mean small opportunity — Spring Hope businesses serve loyal locals and draw visitors from across Nash County and beyond. I build affordable, professional websites that extend your Spring Hope reputation across the region.",
    heroHeadline: "Spring Hope's community is loyal. A website lets more people find you.",
    heroSubheadline: "Web Design, Development & Marketing in Spring Hope, NC",
    nearbyAreas: ["Rocky Mount", "Wilson", "Bunn", "Franklinton", "Youngsville", "Henderson", "Oxford", "Raleigh"],
    industries: [
      "Agriculture & Farm Supply", "Contractors", "Restaurants", "Retail Shops",
      "Home Services", "Auto Services", "Hair Salons", "Medical Practices",
      "Insurance Agencies", "Real Estate Agents", "Childcare Centers", "Veterinarians",
    ],
    metaTitle: "Web Design Spring Hope NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Spring Hope, NC. Trika Studio builds professional websites for Nash County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Spring Hope NC, website design Spring Hope, web developer Spring Hope North Carolina, website development Spring Hope NC, website developer Spring Hope, Nash County web design, Spring Hope small business website",
  },
  {
    slug: "web-design-siler-city-nc",
    city: "Siler City",
    state: "NC",
    county: "Chatham County",
    latitude: "35.7249",
    longitude: "-79.4649",
    description:
      "Siler City is the commercial center of western Chatham County, serving a diverse community of agricultural businesses, manufacturers, and local service providers. As Chatham County grows — fueled by Chatham Park and new development — Siler City businesses are at the center of a regional transformation. I build websites that put Siler City on the digital map.",
    heroHeadline: "Siler City: Chatham County's hidden gem. Let customers find you first.",
    heroSubheadline: "Web Design, Development & Marketing in Siler City, NC",
    nearbyAreas: ["Pittsboro", "Sanford", "Chapel Hill", "Asheboro", "Raleigh", "Lillington", "Durham", "Burlington"],
    industries: [
      "Agriculture & Farm Supply", "Manufacturing & Industrial", "Restaurants", "Contractors",
      "Medical Practices", "Retail Shops", "Auto Services", "Home Services",
      "Insurance Agencies", "Real Estate Agents", "Hair Salons", "Dental Offices",
    ],
    metaTitle: "Web Design Siler City NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design in Siler City, NC. Trika Studio builds professional websites for Chatham County businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Siler City NC, website design Siler City, web developer Siler City North Carolina, website development Siler City NC, website developer Siler City, Chatham County web design, Siler City small business website",
  },
];
